namespace $.$$ {

	export class $shm_sort extends $.$shm_sort {

		@ $mol_mem
		sort_by( next?: string ): string {
			return this.$.$mol_state_local.value( this + '.sort_by', next ) ?? ''
		}

		@ $mol_mem
		sort_order( next?: string ): string {
			return this.$.$mol_state_local.value( this + '.sort_order', next ) ?? 'asc'
		}

		option_ids(): readonly string[] {
			return Object.keys( this.options() )
		}

		option_views() {
			return this.option_ids().map( id => this.Option( id ) )
		}

		option_label( id: string ) {
			const options = this.options()
			return options[ id as keyof typeof options ] ?? id
		}

		@ $mol_mem_key
		option_selected( id: string ) {
			return this.sort_by() === id
		}

		sort_order_toggle() {
			this.sort_order( this.sort_order() === 'asc' ? 'desc' : 'asc' )
		}

		option_click( id: string ) {
			if( this.sort_by() === id ) this.sort_order_toggle()
			else this.sort_by( id )
		}

	}

	export class $shm_sort_item extends $.$shm_sort_item {
		icon() {
			return this.sort_order() == 'asc'
				? [this.Ascending()]
				: [this.Descending()]
		}
	}

}
